import type { HTMLAttributes } from "react";
import { cn } from "../../lib/cn";

type Tone = "default" | "muted" | "danger" | "warning" | "success";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
	tone?: Tone;
}

const TONE: Record<Tone, string> = {
	default: "border-slate-800 bg-slate-900/60",
	muted: "border-slate-800 bg-slate-900/40",
	danger: "border-rose-900/60 bg-rose-950/40",
	warning: "border-amber-900/40 bg-amber-950/30",
	success: "border-emerald-700/50 bg-emerald-950/30",
};

/** Bordered surface used by every section / banner / panel. */
export function Card({
	tone = "default",
	className,
	children,
	...rest
}: CardProps) {
	return (
		<div
			className={cn("rounded-lg border p-4", TONE[tone], className)}
			{...rest}
		>
			{children}
		</div>
	);
}
